const LEGAL_PROCEED_TEXT =
  'Ao prosseguir com sua localização atual ou CEP, dados adicionais serão solicitados na finalização do pedido.'

const LEGAL_IMPORTANT_TEXT =
  'Importante: Após a conclusão do pedido, não será possível fazer alterações no endereço selecionado para entrega.'

export function GuestPostalLegalNotices() {
  return (
    <div className="flex flex-col gap-3 w-full text-sm font-normal text-postal-muted text-left">
      <p>{LEGAL_PROCEED_TEXT}</p>
      <p>{LEGAL_IMPORTANT_TEXT}</p>
    </div>
  )
}
